import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import RouteLayout from "./components/RouteLayout/RouteLayout";
import Main from "./pages/Main/Main";
import Faq from "./pages/Faq/Faq";
import AboutUs from "./pages/AboutUs/AboutUs";
import ContactUs from "./pages/ContactUs/ContactUs";
import Products from "./pages/Products/Products";
import ProductSingle from "./pages/ProductSingle/ProductSingle";
import Cart from "./pages/Cart/Cart";
import Blog from "./pages/Blog/Blog";
import { useSelector } from "react-redux";
import BlogSingle from "./pages/BlogSingle/BlogSingle";
import Representation from "./pages/Representation/Representation";
import Guaranties from "./pages/Guaranties/Guaranties";
import GuarantiesCheckCode from "./pages/GuarantiesCheckCode/GuarantiesCheckCode";
import OtherPages from "./pages/OtherPages/OtherPages";
import NotFound from "./pages/NotFound/NotFound";
import Login from "./pages/OtpLogin/Login";
import Forgot from "./pages/Forgot/Forgot";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ChangeAddress from "./pages/ChangeAddress/ChangeAddress";
import PaymentAccept from "./pages/PaymentAccept/PaymentAccept";
import PaymentFail from "./pages/PaymentFail/PaymentFail";
import MobileProductCategory from "./pages/MobileProductCategory/MobileProductCategory";
import Profile from "./pages/Profile/Profile";
import LittleRouteLayout from "./components/LittleRouteLayout/LittleRouteLayout";
import React from "react";
import RegisterSupplier from "./pages/RegisterSupplier/RegisterSupplier";
import ServicesCenter from "./pages/ServicesCenter/ServicesCenter";
import "react-loading-skeleton/dist/skeleton.css";
import Markets from "./pages/Markets/Markets";
import ComSoonEn from "./pages/ComSoonEn/ComSoonEn";
import ComSoonTr from "./pages/ComSoonTr/ComSoonTr";
import ComSoonAr from "./pages/ComSoonAr/ComSoonAr";
import MarketSingle from "./pages/MarketSingle/MarketSingle";

const App = () => {
  const user = useSelector((state) => state.user);
  return (
    <React.Fragment>
      <BrowserRouter>
        <Switch>
          <RouteLayout path="/login" exact component={Login} activePage="login" />
          <RouteLayout
            path="/supplierRegister/:phoneNumber"
            exact
            component={RegisterSupplier}
            activePage="supplierRegister"
          />
          <Route path="/changePasswordByCode" exact component={Forgot} activePage="login" />
          <Route path="/changePassword" exact component={ResetPassword} activePage="login" />
          <RouteLayout path="/profile" exact component={Profile} activePage="profile" />
          <RouteLayout path="/services" exact component={ServicesCenter} activePage="services" />
          <RouteLayout showCategory={true} path="/" exact component={Main} activePage="home" />
          <RouteLayout path="/faq" exact component={Faq} activePage="faq" />
          <RouteLayout path="/aboutus" exact component={AboutUs} activePage="about" />
          <RouteLayout path="/contactus" exact component={ContactUs} activePage="contact" />
          <RouteLayout showCategory={true} path="/markets" exact component={Markets} activePage="markets" />
          <RouteLayout path="/markets/:slug" component={MarketSingle} activePage="product" />
          <RouteLayout showCategory={true} path="/products" exact component={Products} activePage="product" />
          <RouteLayout showCategory={true} path="/products/:slug" component={ProductSingle} activePage="product" />
          <RouteLayout path="/cart" exact component={Cart} activePage="shop" />
          <RouteLayout path="/blog" exact component={Blog} activePage="blog" />
          <RouteLayout path="/blog/:slug" exact component={BlogSingle} activePage="blog" />
          <RouteLayout path="/representation" exact component={Representation} />
          <RouteLayout path="/guaranties" exact component={Guaranties} />
          <RouteLayout path="/guarantiesCheckCode" exact component={GuarantiesCheckCode} />
          <RouteLayout path="/pages/:slug" exact component={OtherPages} />
          <RouteLayout path="/changeAddress" exact component={ChangeAddress} activePage="shop" />
          <RouteLayout path="/paymentstatus/success" exact component={PaymentAccept} activePage="shop" />

          <RouteLayout path="/commingSoon/en" exact component={ComSoonEn} activePage="shop" />
          <RouteLayout path="/commingSoon/ar" exact component={ComSoonAr} activePage="shop" />
          <RouteLayout path="/commingSoon/tr" exact component={ComSoonTr} activePage="shop" />

          <RouteLayout path="/paymentstatus/fail" exact component={PaymentFail} activePage="shop" />
          <RouteLayout path="/category" exact component={MobileProductCategory} activePage="product" />
          <Route path="/404" component={NotFound} />
          <Redirect to="/404" />
        </Switch>
      </BrowserRouter>
      <ToastContainer autoClose={5000} rtl={true} position="top-center" />
    </React.Fragment>
  );
};

export default App;
